import { Grid } from '@material-ui/core';
import { Button, Col, Row, Tag, Card } from 'antd';
import React, { useState } from 'react';
import DetailItem from '../../CSIComponents/DetailItem';
import Edit from './Edit'
import PageContainer from '../../CSIComponents/PageContainer';
import { isTagsDisplayed } from '@helpers/FeatureFlags'

interface propsTypes {
  isEditable?: void | any,
  cancelEditable?: void | any,
  disableTabPanes?: void | any,
  detail?: any,
  cancelAndSave?: void | any,
  editFlag: any,
  tableCurrentData: any,
  deleteJump?: any,
  setDisabledFlag?: any
}
const Detail = (props: propsTypes) => {
  const [detailInfo, setDetailInfo] = useState(props.tableCurrentData);
  const resetDetailInfo = (data: any) => {
    setDetailInfo(data)
  }

  const [editFlag, setEditFlag] = useState(false);
  const [showEditBtn, setShowEditBtn] = useState(true)
  const handleEditClick = () => {
    setEditFlag(!editFlag);
    props.isEditable();
    props.setDisabledFlag(true)
    setShowEditBtn(false)
  }
  const handelCancelBtnClick = () => {
    setShowEditBtn(true)
    setEditFlag(!editFlag);
    props.setDisabledFlag(false)
    props.cancelEditable();
  }
  return (
    <>
      {showEditBtn ?
        <PageContainer>
          <Card style={{ marginBottom: '60px' }}>
            <Grid item xs={12} className="p-0">
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                {showEditBtn ? <div style={{ margin: '0 10px 0 0' }}>
                  <Button type='primary' className='db-edit-btn' onClick={props.cancelAndSave}>Back</Button>
                </div> : null}

                {showEditBtn ? <div><Button type='primary' className='db-edit-btn' onClick={handleEditClick}>Edit</Button></div> : null}
              </div>
            </Grid>
            <Grid item xs={12} className="p-0">
              <div style={{ fontWeight: 'bold', fontSize: 14, color: '#333' }}>{detailInfo.name}</div>
            </Grid>
            <Row gutter={24}>
              <Col span={6} className="col-margin">
                <DetailItem value={detailInfo.name} label='Name' />
              </Col>
              <Col span={6} className="col-margin">
                <DetailItem value={detailInfo.category} label='Category' />
              </Col>
              <Col span={6} className="col-margin">
                <DetailItem value={detailInfo.type} label='Type' />
              </Col>
              <Col span={5}></Col>
              <Col span={12} className="col-margin">
                <DetailItem value={detailInfo.typedetail} label='Type Detail' />
              </Col>
              <Col span={6} className="col-margin">
                <DetailItem value={detailInfo.avail} label='Availability' />
              </Col>
              <Col span={5}></Col>

              <Col span={6} className="col-margin">
                <DetailItem value={detailInfo.id} label='Service ID' />
              </Col>
              <Col span={6} className="col-margin">
                <DetailItem value={detailInfo.quantity} label='Quantity' />
              </Col>
              <Col span={6} className="col-margin">
                <DetailItem value={detailInfo.included} label='Included in Room Rate' />
              </Col>
              <Col span={5}></Col>

              <Col span={6} className="col-margin">
                <DetailItem value={detailInfo.proximity} label='Proximity' />
              </Col>
              <Col span={6} className="col-margin">
                <DetailItem value={detailInfo.distance} label='Distance' />
              </Col>
              <Col span={6} className="col-margin">
                <DetailItem value={detailInfo.uom} label='Measurement Unit' />
              </Col>
              <Col span={6} className="col-margin"></Col>
              <Col span={6} className="col-margin">
                { detailInfo.lanyoncomments &&
                <DetailItem value={detailInfo.lanyoncomments} label='Lanyon Comments' />
                }
              </Col>
              <Col span={6}></Col>
              { isTagsDisplayed &&
                <Col span={18} className="col-margin">
                  <div style={{ display: 'inline-block', width: '100%' }}>
                    <div style={{ width: '100%', fontSize: 12, color: '#999999', height: '24px' }}>Selected Tags</div>
                    <div style={{ width: '100%', padding: '0 5px', fontSize: '14px', height: '32px', marginTop: '5px', lineHeight: '32px' }}>
                      {
                        detailInfo.tags && detailInfo.tags.split(' | ').map((item: any, index: any) => {
                          return <Tag key={index}>{item}</Tag>
                        })
                      }
                    </div>
                  </div>
                </Col>
              }
              <Col span={5}></Col>
            </Row>
          </Card>
        </PageContainer>
        : <Edit
          deleteJupm={props.cancelAndSave}
          tableCurrentData={detailInfo}
          handelCancelBtnClick={handelCancelBtnClick}
          resetDetailInfo={resetDetailInfo}
          isTagsDisplayed={isTagsDisplayed}
        />}

    </>
  );
}
export default Detail;
